export const FETCH_SLIDER_MANAGEMENT_LIST = 'FETCH_SLIDER_MANAGEMENT_LIST';
export const CREATE_SLIDER_MANAGEMENT_LIST = 'CREATE_SLIDER_MANAGEMENT_LIST';
export const DELETE_SLIDER_MANAGEMENT_LIST = 'DELETE_SLIDER_MANAGEMENT_LIST';
export const PATCH_SLIDER_MANAGEMENT_LIST = 'PATCH_SLIDER_MANAGEMENT_LIST';
export const ADD_STORY_TO_STORY_LIST="ADD_STORY_TO_STORY_LIST";